<template>
  <div class="color-card-container">
    <!-- 面包屑导航（模仿标签页样式） -->
    <div class="top-tab" v-if="menuClickRecordss.length > 0">
      <!-- 首页（固定项） -->
      <div
        class="item"
        @click="goToPath('/publish-clothes/basicData/basicDatas')"
      >
        <span>首页</span>
        <!-- 首页不显示关闭按钮 -->
      </div>
      <!-- 遍历Vuex中的菜单记录生成标签页 -->
      <div
        class="item"
        v-for="(item, index) in menuClickRecordss"
        :key="index"
        @click="goToPath(item.path)"
      >
        <span>{{ item.title }}</span>
        <!-- 关闭按钮 - 添加点击事件 -->
        <i
          class="close el-icon-close"
          title="关闭"
          @click.stop="handleCloseTab(index, item)"
        />
      </div>
    </div>
    <!-- 路由视图 -->
    <router-view />
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";

const store = useStore();
const router = useRouter();

// 获取vuex getters
const menuClickRecordss = computed(() => store.getters.menuClickRecordss);

// 方法
const goToPath = (path) => {
  router.push({ path });
};

const handleCloseTab = async (index, item) => {
  console.log("关闭当前的路由是什么：", item);
  try {
    // 调用vuex action
    await store.dispatch("removeMenuClickRecordS", index);
    sessionStorage.removeItem(item.path);
    // 强制跳转首页
    goToPath("/publish-clothes/basicData/basicDatas");
  } catch (error) {
    console.error("关闭标签页失败：", error);
  }
};
</script>

<style scoped>
/* 原有样式保持不变 */
.color-card-container {
  padding-top: 49px;
  background-color: #fff;
  min-height: calc(100vh - 80px);
  position: relative;
}
.top-tab {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
  padding: 10px 12px;
  box-sizing: border-box;
}
.top-tab .item {
  padding: 4px 5px 4px 10px;
  color: #666;
  border: 1px solid #666;
  border-radius: 3px;
  font-size: 14px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;
  user-select: none;
}
.top-tab .item + .item {
  margin-left: 10px;
}
.top-tab .item span {
  white-space: nowrap;
}
.top-tab .item .close {
  margin-left: 5px;
  font-size: 16px;
}
.top-tab .item:hover {
  background-color: #f5f5f5;
}
/* 新增：关闭按钮hover效果优化 */
.top-tab .item .close:hover {
  color: #ff4d4f; /* 红色强调关闭操作 */
}
</style>
